import { format } from '@office-start/string-formatter-utility';
import { useMemo } from 'react';
export var useFirstRunAriaLabel = function (_a) {
    var ariaLabel = _a.ariaLabel, idx = _a.idx, slideGroupLength = _a.slideGroupLength;
    return useMemo(function () {
        var firstRunAriaLabel = format(ariaLabel, (idx + 1).toString(), slideGroupLength.toString());
        return firstRunAriaLabel;
    }, [ariaLabel, idx, slideGroupLength]);
};
//# sourceMappingURL=useFirstRunAriaLabel.js.map